import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
  text-align: center;
`;

export const TabsWrapper = styled.div`
  margin-bottom: 32px;
`;

export const cssNudgeDialog = css`
  max-width: 152px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  z-index: 1;
  white-space: pre;
`;

export const VideoWrapper = styled.video`
  width: 360px;

  ${({ theme }) => theme.media.mobile} {
    width: 100%;
  }
`;
